import { NgClass } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { Tooltip } from 'primeng/tooltip';
import { SpsTableComponent } from '../../../../custom/components/sps-table/sps-table.component';
import { BasePayoutFilesComponent } from '../../base/base-payout-files.component';

@Component({
  selector: 'app-payout-creditcard-view',
  imports: [
    Button,
    Card,
    PrimeTemplate,
    Tooltip,
    NgClass,
    SpsTableComponent
  ],
  templateUrl: './payout-creditcard-view.component.html',
})
export class PayoutCreditcardViewComponent extends BasePayoutFilesComponent implements AfterViewInit {

  protected tableConfigKeyName = 'SPS_PAYOUT_CREDITCARD_VIEW';
  protected tableRowsKeyName = 'PAYOUT_CREDITCARD_VIEW_ROWS';

  ngAfterViewInit() {
    /**
     * Initialize Breadcrumb-Items
     */
    setTimeout(() => {
      this.i18n.breadcrumbMenuItems.set([
        {
          icon: 'pi pi-home',
          i18nLabelKey: 'MENUDASHBOARD',
          label: this.i18n.i18nLng()['MENUDASHBOARD'],
          routerLink: ['/dashboard'],
          routerLinkActive: false,
        },
        {
          i18nLabelKey: 'MENUPAYOUTFILES',
          label: this.i18n.i18nLng()['MENUPAYOUTFILES'],
          routerLinkActive: false,
        },
        {
          i18nLabelKey: 'CREDITCARD',
          label: this.i18n.i18nLng()['CREDITCARD'],
          routerLinkActive: true,
        },
      ]);
    }, 50);
  }

}
